<template>
  <cms-section
    v-for="item in cmsVariantToLoad"
    :key="item.id"
    :section="{ name: item.id, items: [{ ...item, isFullWidth: true }] }"
  />
</template>

<script setup lang="ts">
import type { Experiment } from '#types/components/cms/experiment'
import type { Content, Module } from '#types/content'
import mappings from '#content/mappings'

const { content } = defineProps<{ content: Experiment }>()

const { configP13n: { enableOptimizely } } = useFeatureFlags()
const { decide } = await useOptimizely()
const { query } = useRoute()
const getComponent = (content: Content | Module) => {
  return resolveContentComponent(content, mappings)?.component
}
const mapTargets = (targets) =>
  targets?.map((target) => ({
    ...target,
    component: getComponent(target),
  }))
const getForcedVariantId = (text: string): string => (text.match(/vfcanvas-optimizely_variant_(\d+)/) || [])[1] || ''
const getVariantKey = (key: string): string => (key.match(/\d+-(.+)/) || [])[1] || ''
const getVariantId = (text: string): string => (text.match(/^(\d+)-/) || [])[1] || ''

const forcedVariants = query.p13n_testcontext ? JSON.parse(query.p13n_testcontext as string)?.variants : []
const flagKey = content.experienceId.match(/optimizely_experience_(.+)$/)?.[1] || ''
const forcedVariantsIds = forcedVariants.map((variant) => getForcedVariantId(variant))
const experiment = enableOptimizely ? decide(flagKey) : null
const cmsVariants = forcedVariantsIds?.length
  ? content.variants.find(
    (variant) => forcedVariantsIds.includes(getVariantId(variant.variantId))
  )?.targets
  : content.variants.find(
    (variant) => getVariantKey(variant.variantId) === experiment?.variationKey
  )?.targets
const cmsVariantToLoad = mapTargets(cmsVariants?.length ? cmsVariants : content.baselines)
console.log(`Optimizely variation chosen for component: ${content.id} was ${experiment?.variationKey}`)
</script>
